import { DefaultErrorPage } from '@odmonorepo/core-components';
import { FormattedMessage } from 'react-intl';
import { AppLayout } from '../../Layout/AppLayout';
import LogoOnlyHeader from '../../Layout/Components/Header/LogoOnlyHeader';

export const MaintenancePage = () => (
  <AppLayout
    header={<LogoOnlyHeader />}
    outlet={
      <DefaultErrorPage
        title={<FormattedMessage id="maintenance.heading" defaultMessage="Scheduled Maintenance" />}
        subTitle={<FormattedMessage id="maintenance.subHeading" defaultMessage="We are currently conducting a scheduled maintenance event." />}
        message={<FormattedMessage id="maintenance.message" defaultMessage="We apologize for the inconvenience and look forward to working with you. Thank you for your patience." />}
        customerServiceCard={false}
      />
    }
  />
);
export default MaintenancePage;
